import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Flex, Box, Copy, themeColor, Currency } from '@elparking/components'
import styled from 'styled-components'
import { transparentize } from 'polished'

import ParkingRestrictions from 'commons/js/components/ParkingRestrictions'

import { STATUS_UNAVAILABLE_RELEASE } from 'commons/js/constants'

import { BookingProductType } from 'parking-availability/js/propTypes'

const boxShadow = ({ isSelected }) => isSelected ? '0 2px 8px 0 rgba(0,0,0,0.1)' : 'none'
const borderWidth = ({ isSelected }) => isSelected ? '2px' : '1px'
const borderColor = ({ isSelected }) => isSelected ? themeColor('main') : themeColor('gray20')
const hoverBorderColor = ({ isDisabled }) => !isDisabled ? themeColor('main') : themeColor('gray20')
const alphaMainColor = (props) => transparentize(0.90, themeColor('main')(props))

const Card = styled.div`
    background-color: ${themeColor('white')};
    border: ${borderWidth} solid ${borderColor};
    border-radius: 2px;
    padding: 1em;
    box-shadow: ${boxShadow};
    transition: border-color 0.25s;

    &:hover {
        border-color: ${hoverBorderColor};
    }
`

const Badge = styled.div`
    display: flex;
    border: 1px solid ${alphaMainColor};
    border-radius: 2px;
    padding: 0em 0.2em;
    background-color: ${alphaMainColor};
`

function getRestrictions (bookingProduct) {
    return bookingProduct && bookingProduct.product
}

const isReleaseAvailabilityStatus = (availabilityStatus) => STATUS_UNAVAILABLE_RELEASE.includes(availabilityStatus)

class BookingProduct extends PureComponent {
    static propTypes = {
        bookingProduct: BookingProductType,
        isSelected: PropTypes.bool,
        isDisabled: PropTypes.bool,
    }

    render () {
        const { isSelected, isDisabled, bookingProduct } = this.props
        const { product, availability } = bookingProduct

        return (
            <Card isSelected={isSelected} isDisabled={isDisabled}>
                <Flex w='100%' flexWrap='wrap' mb='0.5em'>
                    <Flex w='100%' flex='1' mr='0.5em' style={{ minWidth: '0' }}>
                        <Copy as='span' title={product.name} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} padding='0' size='medium' fontWeight='medium' color={isSelected ? 'main' : 'gray'}>
                            {product.name}
                        </Copy>
                    </Flex>
                    {availability.priceQty && <Flex w='100%' flex='0' style={{'borderLeft': '1px solid #DEDEDE'}} pl='0.5em' alignItems='center'>
                        <Box mr='0.5em'>
                            <Copy padding='0' size='medium' fontWeight='medium' color={isSelected ? 'main' : 'gray'} align='right'>
                                <Currency qty={availability.priceQty} />
                            </Copy>
                        </Box>
                        {product.isDefault &&
                            <Box>
                                <Badge>
                                    <Copy as='span' padding='0' color='main' size='xxxSmall' fontWeight='book'>
                                        <FormattedMessage
                                          defaultMessage='Popular'
                                        />
                                    </Copy>
                                </Badge>
                            </Box>}
                    </Flex>}
                </Flex>
                <Box w='100%'>
                    <Copy style={{whiteSpace: 'pre-line'}} padding='0' size='xxSmall' fontWeight='regular' color='gray'>
                        {product.description}
                    </Copy>
                </Box>
                {isReleaseAvailabilityStatus(availability.availabilityStatus) && <Box w='100%' mt='1em'>
                    <ParkingRestrictions restrictions={getRestrictions(bookingProduct)} />
                </Box>}
            </Card>
        )
    }
}

export default BookingProduct
